<template>
  <div class="legend-tag">
    <div class="item-wrap">
      <div
        class="item"
        v-for="(item,index) in chartData"
        :key="index"
        :style="{
          marginBottom:config.marginBot+'px'
        }"
      >
        <span
          class="icon"
          :style="{
            backgroundColor: config.color[index],
            width: config.tag.width +'px',
            height: config.tag.height +'px',
            borderRadius: config.tag.borderRadius
          }"
        ></span>
        <span
          class="name"
          :style="{
            ...config.textStyle,
            fontSize: config.textStyle.fontSize +'px',
            marginLeft:'15px'
          }"
        >{{ item[config['xField']] }}</span>
        <span
          class="count"
          :style="{
            ...config.countStyle,
            fontSize: config.countStyle.fontSize +'px'
          }"
        >{{ item[config['yField']] }}%</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegendTag',
  components: {

  },
  props: {
    config: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  }
}
</script>

<style scoped lang="stylus">
.legend-tag
  height 100%
  .item-wrap
    display flex
    flex-direction: column
  .item
    display flex
    align-items center
    .count
      margin-left: auto
    .icon
      overflow hidden
  span
    display: inline-block
</style>
